import React from 'react';
import $ from 'jquery';

export const StockMarketGameFunctions = ({ isAuthenticated, email, name, pathName }) => {
  function loadPortfolio() {
    var headers = {
      "Accept": "application/json",
      "x-api-key": process.env.REACT_APP_API_PORTFOLIO_KEY,
    };

    var apiEndpoint = process.env.REACT_APP_API_PORTFOLIO_URL + email;

    return new Promise((resolve, reject) => {
      $.ajax({
        type: "GET",
        url: apiEndpoint,
        headers: headers,
        contentType: "application/json",
        success: function (response) {
          if (response && response.customMessage && response.customMessage.result) {
            resolve(response.customMessage.result.data);
          } else {
            reject("Unexpected response structure. Please try again.");
          }
        },
        error: function () {
          reject("Error calling the Portfolio API. Please try again later.");
        },
      });
    });
  }

  function loadUser() {
    var headers = {
      "Accept": "application/json",
      "x-api-key": process.env.REACT_APP_API_PORTFOLIO_KEY,
    };

    var apiEndpoint = process.env.REACT_APP_API_PORTFOLIO_URL + email + "/getusersummary?name=" + encodeURIComponent(name);
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "GET",
        url: apiEndpoint,
        headers: headers,
        contentType: "application/json",
        success: function (response) {
          if (response && response.customMessage && response.customMessage.result) {
            resolve(response.customMessage.result.data);
          } else {
            reject("Unexpected response structure. Please try again.");
          }
        },
        error: function () {
          reject("Error calling the User Summary API. Please try again later.");
        },
      });
    });
  }

  function loadUserTransactions() {
    var headers = {
      "Accept": "application/json",
      "x-api-key": process.env.REACT_APP_API_PORTFOLIO_KEY,
    };

    var apiEndpoint = process.env.REACT_APP_API_PORTFOLIO_URL + email + "/getusertransactions";

    return new Promise((resolve, reject) => {
      $.ajax({
        type: "GET",
        url: apiEndpoint,
        headers: headers,
        contentType: "application/json",
        success: function (response) {
          if (response && response.customMessage && response.customMessage.result) {
            resolve(response.customMessage.result.data);
          } else {
            reject("Unexpected response structure. Please try again.");
          }
        },
        error: function () {
          reject("Error calling the User Transactions API. Please try again later.");
        },
      });
    });
  }

  function getStockPrice(stockSymbol, retries = 3) {
    const headers = {
      "Accept": "application/json",
      "x-api-key": process.env.REACT_APP_API_PORTFOLIO_KEY,
      "Content-Type": "application/json",
    };

    const apiEndpoint = `${process.env.REACT_APP_API_STOCKPRICE_URL}`;

    return new Promise((resolve, reject) => {
      const makeRequest = (attempt) => {
        $.ajax({
          type: "POST",
          url: apiEndpoint,
          headers: headers,
          data: JSON.stringify({ stock_symbol: stockSymbol }),
          contentType: "application/json",
          dataType: "json",
          success: function (response) {
            const stockData = response?.customMessage?.result?.data;
            if (stockData && stockData.ticker && stockData.price != null) {
              resolve({
                ticker: stockData.ticker,
                name: stockData.name,
                price: stockData.price,
                exchange: stockData.exchange,
                updated: stockData.updated,
                currency: stockData.currency,
              });
            } else {
              reject("Unexpected response structure.");
            }
          },
          error: function (xhr) {
            console.error(`Attempt ${attempt} failed for ${stockSymbol}`, xhr);

            if (attempt < retries) {
              console.warn(`Retrying (${attempt + 1}/${retries})...`);
              setTimeout(() => makeRequest(attempt + 1), 1000); // 1-second delay before retry
            } else {
              if (
                xhr.status === 400 &&
                xhr.responseJSON?.errorMessage?.trace?.message === "ERR_BAD_REQUEST"
              ) {
                reject("Incorrect stock symbol. Please try again.");
              } else {
                reject("Error fetching stock price after multiple attempts.");
              }
            }
          },
        });
      };

      makeRequest(1); // start with first attempt
    });
}

  function buyStock(stockSymbol, quantity, lastPrice) {
    const headers = {
      "Accept": "application/json",
      "x-api-key": process.env.REACT_APP_API_PORTFOLIO_KEY,
    };

    const payload = JSON.stringify({
      stock_symbol: stockSymbol,
      quantity: quantity,
      transaction_type: "BUY",
      price: lastPrice,
    });

    var apiEndpoint = process.env.REACT_APP_API_PORTFOLIO_URL + email + "/addtransaction";

    return new Promise((resolve, reject) => {
      $.ajax({
        type: "POST",
        url: apiEndpoint,
        headers: headers,
        data: payload,
        contentType: "application/json",
        success: function (response) {
          resolve(response);
        },
        error: function () {
          reject("Error buying stock.");
        },
      });
    });
  }

  function sellStock(stockSymbol, quantity, lastPrice) {
    const headers = {
      "Accept": "application/json",
      "x-api-key": process.env.REACT_APP_API_PORTFOLIO_KEY,
    };

    const payload = JSON.stringify({
      stock_symbol: stockSymbol,
      quantity: quantity,
      transaction_type: "SELL",
      price: lastPrice,
    });

    var apiEndpoint = process.env.REACT_APP_API_PORTFOLIO_URL + email + "/addtransaction";

    return new Promise((resolve, reject) => {
      $.ajax({
        type: "POST",
        url: apiEndpoint,
        headers: headers,
        data: payload,
        contentType: "application/json",
        success: function (response) {
          resolve(response);
        },
        error: function () {
          reject("Error selling stock.");
        },
      });
    });
  }

  return { loadPortfolio, loadUser, getStockPrice, buyStock, sellStock, loadUserTransactions };
};
